import { useState, useEffect } from 'react'
import { pointService } from '../services/pointService'
import { clientService } from '@/modules/clients/services/clientService'
import { userService } from '@/modules/users/services/userService'
import { branchService } from '@/modules/branches/services/branchService'
import type { Point } from '../types'
import type { Client } from '@/modules/clients/types'
import type { User } from '@/modules/users/types'
import type { BranchOffice } from '@/modules/branches/types'

interface PointRelatedData {
  client: Client | null
  user: User | null
  branch: BranchOffice | null
}

export function usePoint(id: number) {
  const [data, setData] = useState<Point | null>(null)
  const [related, setRelated] = useState<PointRelatedData>({ client: null, user: null, branch: null })
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const point = await pointService.getById(id)
        setData(point)

        const [client, user, branch] = await Promise.allSettled([
          clientService.getById(point.id_client),
          userService.getById(point.id_user),
          branchService.getById(point.id_branch_office),
        ])

        setRelated({
          client: client.status === 'fulfilled' ? client.value : null,
          user: user.status === 'fulfilled' ? user.value : null,
          branch: branch.status === 'fulfilled' ? branch.value : null,
        })
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Error al cargar transacción')
      } finally {
        setIsLoading(false)
      }
    }
    fetchData()
  }, [id])

  return { data, related, isLoading, error }
}
